import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { createStatistic } from 'store/app/actions';

export const submitMemberMeasures = (payload: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityClaimGenerator.isSubmittingMeasure) { return Promise.reject(); }

  dispatch({ type: types.SUBMIT_MEMBER_MEASURE_REQUEST });

  return api.eligibility.claimGenerator.submitMemberMeasures(payload)
    .then((res: any) => {

      dispatch({
        type: types.SUBMIT_MEMBER_MEASURE_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'HEDIS UPDATE SUCCESS', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SUBMIT_MEMBER_MEASURE_FAILURE,
        payload,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'HEDIS UPDATE FAILURE', 
        sessionStorage.getItem('user_id')! 
      ));

      return Promise.reject(payload);
    });
};

export const saveHedisClaim = (claim: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityClaimGenerator.isSavingHedisClaim) { return Promise.reject(); }

  dispatch({ type: types.SAVE_HEDIS_CLAIM_REQUEST });

  return api.eligibility.claimGenerator.saveHedisClaim(claim)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_HEDIS_CLAIM_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'HEDIS CLAIM SUCCESS', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_HEDIS_CLAIM_FAILURE,
        payload,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'HEDIS CLAIM FAILURE', 
        sessionStorage.getItem('user_id')! 
      ));

      return Promise.reject(payload);
    });
};

export const updateMemberMeasureForClaimSubmission = (measure: any, claimStatus: string, measureStatus: string, measureYear: any, claimReferenceNo: string) =>
  (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  if (getState().rootReducer.eligibilityClaimGenerator.updatingClaimStatus) { return Promise.reject(); }

  dispatch({ type: types.SAVE_CLAIM_STATUS_REQUEST });

  const updateModel = {
    "RmiMeasureCode": measure.RmiMeasureCode,
    "RmiHedisMeasureDetailId": measure.RmiHedisMeasureDetailId,
    "RmiHedisMeasureDetailId2": measure?.RmiHedisMeasureDetailId2 || null,
    "RmiMembMpiNo": measure.RmiMembMpiNo,
    "RmiProvKeyId": measure.RmiProvKeyId,
    "RmiDosFrom": measure.RmiDosFrom,
    "RmiDosTo": measure.RmiDosTo,
    "RmiClaimStatus": claimStatus,
    "RmiMeasureStatus": measureStatus,
    "RmiMeasureYear": parseInt(measureYear),
    "RmiClaimReferenceNo": claimReferenceNo,
    "RmiDocumentId": null
  };

  return api.eligibility.claimGenerator.updateMemberMeasureForClaimSubmission(updateModel)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_CLAIM_STATUS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_CLAIM_STATUS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
  };

/**
 * This validates claim final submission page after hitting the submit button
 * @param claimModel - claimModel contains PortalClaimMaster, PortalClaimDetails, PortalClaimDiags
 * @returns error messages
 */
export const validateHedisClaim = (claimModel: Object) =>
  (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

    if (getState().rootReducer.eligibilityClaimGenerator.validatingHedisClaim) { return Promise.reject(); }

  dispatch({ type: types.VALIDATE_HEDIS_CLAIM_REQUEST });

  return api.eligibility.claimGenerator.validateHedisClaim(claimModel)
    .then((res: any) => {

      dispatch({
        type: types.VALIDATE_HEDIS_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.VALIDATE_HEDIS_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
